import { CardContent, Skeleton, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { Card } from '../../../card/card.style';

import { CardTitle, InfoTitle, Table } from '../dialog.styles';

export const SurveyResultsSkeleton = () => (
  <Card>
    <CardContent sx={{ paddingBottom: 0 }}>
      <CardTitle>
        Survey Results
        <span>
          <Skeleton variant="text" width={100} height={20} />
        </span>
      </CardTitle>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell style={{ width: '22%' }}>
              <InfoTitle>Score:</InfoTitle>
            </TableCell>
            <TableCell>
              <Skeleton variant="text" width={80} height={20} />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={{ width: '22%' }}>
              <InfoTitle>Referrability:</InfoTitle>
            </TableCell>
            <TableCell>
              <Skeleton variant="text" width={60} height={20} />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={{ width: '22%' }}>
              <InfoTitle>Survey Details:</InfoTitle>
            </TableCell>
            <TableCell>
              <Skeleton variant="text" width="80%" height={20} />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>#</TableCell>
            <TableCell width="80%">Question</TableCell>
            <TableCell>Score</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {[...Array(5)].map((_, index) => (
            <TableRow key={`tr-${String(index)}`}>
              <TableCell>
                <Skeleton variant="text" width={80} height={20} />
              </TableCell>
              <TableCell width="80%">
                <Skeleton variant="text" width="80%" height={20} />
              </TableCell>
              <TableCell>
                <Skeleton variant="text" width={60} height={20} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </CardContent>
  </Card>
);
